import Profile from './Profile.graphql';

export const ProfileQuery = Profile;
